<!-- tap on top starts-->
<div class="tap-top" (click)="tapToTop()" 
  [ngStyle]="{ 'display': show ? 'block' : 'none' }">
  <i class="fas fa-chevron-circle-up"></i>
</div>
<!-- tap on tap ends-->